import { render, staticRenderFns } from "./AnnotatedImageTree.vue?vue&type=template&id=852e323e"
import script from "./AnnotatedImageTree.vue?vue&type=script&lang=js"
export * from "./AnnotatedImageTree.vue?vue&type=script&lang=js"
import style0 from "./AnnotatedImageTree.vue?vue&type=style&index=0&id=852e323e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports